import { render, staticRenderFns } from "./ProductComparisonModal.vue?vue&type=template&id=6c9b3ae4"
import script from "./ProductComparisonModal.vue?vue&type=script&lang=js"
export * from "./ProductComparisonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports